module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fav-boards"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.parent >= 0) ? _c('div', {
    staticClass: "bread-nav"
  }, [_c('a', {
    staticClass: "button is-info is-outlined is-small",
    on: {
      "click": function($event) {
        _vm.getParent()
      }
    }
  }, [_vm._v("返回")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.boards.length == 0) ? _c('div', {
    staticClass: "empty-tip"
  }, [_c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(" 收藏版面空空如也哦 ")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "columns is-multiline is-mobile is-gapless"
  }, [(_vm.level == 0) ? _c('div', {
    staticClass: "column is-half",
    on: {
      "click": function($event) {
        _vm.jumpToSection()
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.boards), function(board, index) {
    return _c('div', {
      key: board.desc + board.level,
      staticClass: "column is-half",
      on: {
        "click": function($event) {
          _vm.jumpToBoard(board)
        }
      }
    }, [_c('div', {
      staticClass: "card fav-board"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('a', [_c('p', {
      staticClass: "title is-6"
    }, [_vm._v(_vm._s(board.dir ? '[目录]' : '') + " " + _vm._s(board.desc))]), _vm._v(" "), _c('p', {
      staticClass: "sub-title is-6"
    }, [_vm._v("今日" + _vm._s(board.new) + "个讨论")])])])])])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card fav-board"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('a', [_c('p', {
    staticClass: "title is-6"
  }, [_vm._v("所有版面")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title is-6"
  }, [_vm._v("查找/添加收藏")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5ed1bd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FavBoard.vue
// module id = 244
// module chunks = 1